import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Select,
  MenuItem,
  FormControl,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from '@mui/material';
import useAssignRole from './hooks/useAssignRole';
import { useHistory } from 'react-router-dom';
import { TextField } from '@material-ui/core';
import EditUserDialog from './EditUserDialog';

function AssignRole() {

  const [editUser, setEditUser] = React.useState(null);

  const {
    allUsers,
    allRoles,
    editingUserId,
    handleEditClick,
    selectedRoleId,
    handleRoleChange,
    handleSaveRole,
    handleCancelEdit,
    handleDeleteUser,
    openDeleteModal,
    setOpenDeleteModal,
    selectedUserId,
    setSelectedUserId,
    openResetModal,
    setOpenResetModal,
    resetPasswordData,
    setResetPasswordData,
    resetPasswordError,
    handleResetPassword,
    handleUpdateUser
  } = useAssignRole();

  const history = useHistory();

  return (
    <div className="app-wrapper siteWrapper">
      <div style={{ height: 'calc(100vh - 80px)', width: '100%', paddingTop: '0.5rem' }}>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
          <h2 style={{ fontSize: '1.5rem', margin: 0 }}>Assign Role</h2>
          <Box display="flex" alignItems="center" gap={3}>
            <Button variant="contained" color="primary" onClick={() => history.push('/')}>
              Home
            </Button>
          </Box>
        </Box>

        <TableContainer
          component={Paper}
          sx={{
            marginTop: 2,
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            border: '1px solid #e0e0e0',
            borderRadius: '4px',
          }}>
          <Table
            sx={{
              '& .MuiTableCell-root': {
                borderBottom: '1px solid #e0e0e0',
              },
            }}>
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: '#f5f5f5',
                  '& .MuiTableCell-head': {
                    fontWeight: 600,
                    fontSize: '14px',
                    color: '#424242',
                    padding: '12px 16px',
                    borderBottom: '2px solid #e0e0e0',
                  },
                }}>
                <TableCell>User ID</TableCell>
                <TableCell>Display Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>User Role</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {allUsers.map((user, index) => (
                <TableRow
                  key={user.userId}
                  sx={{
                    backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafafa',
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                    '& .MuiTableCell-body': {
                      padding: '12px 16px',
                      fontSize: '14px',
                      color: '#616161',
                    },
                  }}>
                  <TableCell>{user.userId}</TableCell>
                  <TableCell>{user.displayName}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>{user.roleName}</TableCell>
                  <TableCell>
                    {editingUserId === user.userId ? (
                      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <FormControl
                          size="small"
                          sx={{
                            minWidth: 150,
                            '& .MuiOutlinedInput-root': {
                              fontSize: '14px',
                              '& fieldset': {
                                borderColor: '#e0e0e0',
                              },
                              '&:hover fieldset': {
                                borderColor: '#2196f3',
                              },
                            },
                          }}>
                          <Select value={selectedRoleId ?? ''} onChange={e => handleRoleChange(e.target.value)} displayEmpty>
                            <MenuItem value="" disabled>
                              <em>Select Role</em>
                            </MenuItem>
                            {allRoles.map(role => (
                              <MenuItem key={role.id} value={role.id}>
                                {role.rolename}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <Button
                          size="small"
                          variant="contained"
                          onClick={() => handleSaveRole(user.userId)}
                          sx={{
                            backgroundColor: '#4caf50',
                            textTransform: 'none',
                            fontSize: '13px',
                            padding: '4px 12px',
                            boxShadow: 'none',
                            '&:hover': {
                              backgroundColor: '#45a049',
                              boxShadow: 'none',
                            },
                          }}>
                          Save
                        </Button>
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={handleCancelEdit}
                          sx={{
                            borderColor: '#e0e0e0',
                            color: '#616161',
                            textTransform: 'none',
                            fontSize: '13px',
                            padding: '4px 12px',
                            '&:hover': {
                              borderColor: '#9e9e9e',
                              backgroundColor: '#f5f5f5',
                            },
                          }}>
                          Cancel
                        </Button>
                      </Box>
                    ) : (
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => {
                            setSelectedUserId(user.userId);
                            setOpenResetModal(true);
                          }}
                          sx={{
                            borderColor: '#1f634f',
                            color: '#1f634f',
                            textTransform: 'none',
                            fontSize: '13px',
                            padding: '4px 12px',
                            '&:hover': {
                              borderColor: '#1f634f',
                              backgroundColor: '#ffffff',
                            },
                          }}>
                          Reset Password
                        </Button>

                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => setEditUser(user)}
                          sx={{
                            borderColor: '#2196f3',
                            color: '#2196f3',
                            textTransform: 'none',
                            fontSize: '13px',
                            padding: '4px 12px',
                            '&:hover': {
                              borderColor: '#1976d2',
                              backgroundColor: '#e3f2fd',
                            },
                          }}>
                          Edit User
                        </Button>

                        <Button
                          size="small"
                          variant="outlined"
                          color="error"
                          onClick={() => {
                            setSelectedUserId(user.userId);
                            setOpenDeleteModal(true);
                          }}
                          sx={{
                            borderColor: '#f44336',
                            color: '#f44336',
                            textTransform: 'none',
                            fontSize: '13px',
                            padding: '4px 12px',
                            '&:hover': {
                              borderColor: '#d32f2f',
                              backgroundColor: '#ffebee',
                            },
                          }}>
                          Delete
                        </Button>
                      </Box>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <EditUserDialog
        open={!!editUser}
        user={editUser}
        roles={allRoles.map(r => r.rolename)}
        onClose={() => setEditUser(null)}
        onSave={async payload => {
          await handleUpdateUser(payload);
          setEditUser(null);
        }}
      />

      <Dialog
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: { borderRadius: 3, p: 1 },
        }}>
        <DialogTitle sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1 }}>Delete Metadata</DialogTitle>

        <DialogContent sx={{ mt: 1 }}>
          <Typography sx={{ fontSize: '15px' }}>
            Are you sure you want to delete user with ID
            <strong style={{ marginLeft: 4, fontWeight: 'bold' }}>{selectedUserId || null}</strong>
          </Typography>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setOpenDeleteModal(false)} sx={{ textTransform: 'none' }}>
            Cancel
          </Button>

          <Button
            variant="contained"
            style={{ backgroundColor: '#FF2400', color: '#fff' }}
            onClick={() => handleDeleteUser(selectedUserId || null)}
            sx={{ textTransform: 'none' }}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Reset Password Dialog */}
      <Dialog
        open={openResetModal}
        onClose={() => {
          setOpenResetModal(false);
          setResetPasswordData({ password: '', confirmPassword: '' });
        }}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: { borderRadius: 3, p: 1 },
        }}>
        <DialogTitle sx={{ fontWeight: 700 }}>Reset Password</DialogTitle>

        <DialogContent sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            label="New Password"
            type="password"
            fullWidth
            size="small"
            value={resetPasswordData.password}
            onChange={e => setResetPasswordData(prev => ({ ...prev, password: e.target.value }))}
          />
          <TextField
            label="Confirm Password"
            type="password"
            fullWidth
            size="small"
            value={resetPasswordData.confirmPassword}
            onChange={e => setResetPasswordData(prev => ({ ...prev, confirmPassword: e.target.value }))}
          />
          {resetPasswordError && <Typography sx={{ fontSize: '13px', color: '#f44336' }}>{resetPasswordError}</Typography>}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => {
              setOpenResetModal(false);
              setResetPasswordData({ password: '', confirmPassword: '' });
            }}
            sx={{ textTransform: 'none' }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => handleResetPassword(selectedUserId)}
            sx={{ textTransform: 'none', backgroundColor: '#2196f3' }}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AssignRole;